export class DeliveryInstructionLandingFilterVM {
  account: string;
  accountName: string;
  accountCity: string;
  accountState: string;
  updatedDate: string;
  contactName: string;
  isPalletJackReq: string;
  parentAccountNo: string;
}
